import React from "react";
import { NativeSelect, FormControl, InputLabel } from "@material-ui/core";
import { PropTypes } from 'prop-types';

DropDownList.propTypes = {
    value: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    empty: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    helperText: PropTypes.string,
    disabled: PropTypes.bool,
};

DropDownList.defaultProps = {
    id: 'Custom',
    name: "",
    label: "",
    items: [],
    empty: true,
    placeholder: '',
    onChange: () => { },
    helperText: '',
    value: '',
    disabled: false
};
function DropDownList(props) {
    return (
        <FormControl fullWidth>
            <InputLabel style={{ fontSize: '13px' }} variant="standard" htmlFor={props.id}>{props.label}</InputLabel>
            <NativeSelect
                style={{ width: '100%' }}
                disabled={props.disabled}
                onChange={props.onChange}
                value={props.value || ''}
                inputProps={{ name: props.name, id: props.id }}
            >
                {/* <option value='' disabled>Selecciona una opción</option> Opción vacía */}
                {props.items.map((item, index) => {
                    return (
                        <option key={index} value={item.value}>
                            {item.label || item.value} {/* Muestra la etiqueta o el valor del item */}
                        </option>
                    );
                })}
            </NativeSelect>
        </FormControl>
    );
}

export default React.memo(DropDownList);
